// websocketServiceGlobal.js - WebSocket service for COMEX, FOREX, and GLOBAL exchanges (port 8084)
import config from './config';

class WebSocketServiceGlobal {
    constructor(resource, stockIDs, updateStockData, setLastUpdateTime) {
      this.resource = resource;
      this.stockIDs = stockIDs;
      this.updateStockData = updateStockData;
      this.setLastUpdateTime = setLastUpdateTime;
      this.socket = null;
      this.intervalId = null;
      this.jsLastUpdate = null;
    }

    // Helper function to get formatted timestamp
    getTimestamp() {
      return new Date().toLocaleString('en-IN', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit',
        hour12: false 
      });
    }

    setIDs(ids){
      this.stockIDs = ids;
    }

    mergerIDs(newIds){
      this.stockIDs = [...new Set([...this.stockIDs, ...newIds])];
    }
  
    connect() {
      // Use port 8084 for COMEX, FOREX, and GLOBAL exchanges
      const url = config.WS_GLOBAL_URL;
  
      this.socket = new WebSocket(url);
  
      this.socket.onopen = () => {
        console.log(`[${this.getTimestamp()}] WebSocket Global connection opened (port 8084)`);
  
        // Subscribe to all instrument identifiers
        this.stockIDs.forEach((item) => {
          const instrumentIdentifier = item;
          this.socket.send(JSON.stringify({ subscribe: instrumentIdentifier }));
        });
  
        // Send keep-alive ping every 28 seconds
        setInterval(() => {
          if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send("2");
          }
        }, 28000);
  
        // Start the interval for the refresh check
        this.startRefreshCheck();
      };
  
      this.socket.onclose = () => {
        console.log(`[${this.getTimestamp()}] WebSocket Global connection closed`);
      };
  
      this.socket.onmessage = (event) => {
        this.handleMessage(event);
      };
  
      this.socket.onerror = (event) => {
        console.error(`[${this.getTimestamp()}] WebSocket Global error:`, event);
      };
    }
  
    handleMessage(event) {
      const response = event.data;
  
      let jsonData;
      try {
        if (response.includes("ping")) {
          this.socket.send(JSON.stringify("pong"));
        } else if (response.includes(42)) {
          const trimmedResponse = response.slice(2);
          jsonData = JSON.parse(trimmedResponse);
        } else {
          jsonData = JSON.parse(response);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
  
      if (jsonData) {
        if (jsonData[0] === "scrip_data") {
          const data = jsonData[1].data;
          this.updateStockData(data);
        } else {
          this.updateStockData(jsonData);
        }
      }
  
      const currentTime = new Date();
      this.setLastUpdateTime(currentTime);
      this.jsLastUpdate = currentTime;
    }
  
    disconnect() {
      if (this.socket) {
        this.socket.close();
      }
      this.stopRefreshCheck();
    }

    startRefreshCheck() {
      this.intervalId = setInterval(this.refreshCheck.bind(this), 5000);
    }
  
    stopRefreshCheck() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  
    refreshCheck() {
      if (this.jsLastUpdate != null) {
        const nowTime = new Date();
        const timeDiff = Math.abs(nowTime.getTime() - this.jsLastUpdate.getTime());
        const timeDiffInSecond = Math.ceil(timeDiff / 1000);
  
        if (timeDiffInSecond > 10) {
          console.log(`[${this.getTimestamp()}] WebSocket Global reconnecting due to timeout (${timeDiffInSecond}s since last update)`);
          this.socket.close();
          this.connect();
        }
      }
    }
  }
  
  export default WebSocketServiceGlobal;


